// extracted by mini-css-extract-plugin
export var centerText = "_66-8";
export var container = "_66-0";
export var doughnutContainer = "_66-7";
export var legend = "_66-a";
export var legendItemColorDisplay = "_66-b";
export var legendItemLabel = "_66-d";
export var legendItemValue = "_66-c";
export var lg = "_66-5";
export var maxWidth = "_66-9";
export var md = "_66-4";
export var responsive = "_66-6";
export var sm = "_66-3";
export var xs = "_66-2";
export var xxs = "_66-1";